import { JWTSession } from './JWTSession';

export const session = JWTSession.createFromStorage();
